module.exports = __webpack_public_path__ + "static/media/the-all-seeing-eye.30f53b66.svg";